export async function sendOtp(identifier: string) {
  return await fetch('https://api.bowercollective.com/auth/otp-request', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ identifier }),
  })
}

export async function verifyOtp(identifier: string, code: string) {
  return (
    await fetch('https://api.bowercollective.com/auth/otp-verify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ identifier, code }),
    })
  ).json()
}
